document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('TrackingForm');
  const input = document.getElementById('tracking_id');
  const btn = document.getElementById('TrackButton');
  const btnText = btn.querySelector('.btn-text');
  const btnLoading = btn.querySelector('.btn-loading');
  const errorDiv = document.getElementById('TrackingError');
  const resultsDiv = document.getElementById('TrackingResults');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const trackingNo = input.value.trim();
    if (!trackingNo) return;

    // Reset UI
    btnText.classList.add('hidden');
    btnLoading.classList.remove('hidden');
    btn.disabled = true;
    errorDiv.classList.add('hidden');
    resultsDiv.classList.add('hidden');

    try {
      const resp = await fetch('https://oneend-returns-api.oneend.workers.dev/api/track-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ trackingNo })
      });

      if (!resp.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await resp.json();

      // If no valid data or error returned from API
      if (!data || !data.orderId || data.status === 'false') {
        throw new Error('Order not found or invalid tracking number.');
      }

      renderTrackerInfo(data);

    } catch (err) {
      console.error(err);
      errorDiv.textContent = 'Unable to fetch tracking details. Please ensure your tracking ID is correct.';
      errorDiv.classList.remove('hidden');
    } finally {
      btnText.classList.remove('hidden');
      btnLoading.classList.add('hidden');
      btn.disabled = false;
    }
  });

  function formatDate(isoStr, includeTime = false) {
    if (!isoStr) return '';
    const date = new Date(isoStr);
    const opts = { year: 'numeric', month: 'long', day: 'numeric' };
    if (includeTime) {
      opts.hour = '2-digit';
      opts.minute = '2-digit';
    }
    return date.toLocaleDateString(undefined, opts);
  }

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }

  function formatReadableDate(isoStr) {
    if (!isoStr) return 'TBD';
    const date = new Date(isoStr);
    if (isNaN(date.getTime())) return isoStr;

    const day = date.getDate();
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
  }

  function getStepIndex(status) {
    const s = (status || '').toLowerCase();
    if (s === 'delivered') return 3;
    if (s.includes('out for delivery') || s === 'pending pickup') return 2; // Approximations for UI
    if (s.includes('transit') || s.includes('shipped') || s.includes('manifest') || s.includes('picked')) return 2;
    if (s.includes('confirm') || s === 'booked' || s.includes('manifested')) return 1;
    return 0; // Ordered
  }

  function renderTrackerInfo(data) {
    // 1. Order Header
    document.getElementById('ResultOrderId').textContent = data.orderId || '';
    document.getElementById('ResultStatusBadge').textContent = data.status || 'Processing';
    document.getElementById('ResultOrderDate').textContent = formatDate(data.orderDate);

    // 2. Info Grid
    document.getElementById('ResultCourier').textContent = data.fullfilledBy || 'Courier';
    document.getElementById('ResultTrackingNo').textContent = data.awb || input.value;
    document.getElementById('ResultStatusSmall').textContent = data.status || '';
    document.getElementById('ResultInfoEstDate').textContent = formatReadableDate(data.expectedDelivertDate);

    document.getElementById('ResultLastLocation').textContent = data.location || 'N/A';
    if (data.history && data.history.length > 0) {
      document.getElementById('ResultLastUpdateMsg').textContent = data.history[0].remarks || data.history[0].status;
      document.getElementById('ResultLastUpdateTime').textContent = formatDate(data.history[0].scannedOn, true);
    }

    // 3. Horizontal Progress
    const estDateEl = document.getElementById('ResultEstimatedDate');
    estDateEl.textContent = formatReadableDate(data.expectedDelivertDate);

    const currentStepIndex = getStepIndex(data.status);

    const stepsData = [
      { id: 'ordered', label: 'Ordered', date: formatDate(data.orderDate) },
      { id: 'confirmed', label: 'Confirmed', date: currentStepIndex >= 1 ? formatDate(data.orderDate) : '' },
      { id: 'shipped', label: 'Shipped', date: currentStepIndex >= 2 ? formatDate(data.statusDate) : '' },
      { id: 'delivered', label: 'Delivered', date: currentStepIndex >= 3 ? formatDate(data.statusDate) : '' }
    ];

    const progressContainer = document.getElementById('ProgressSteps');
    progressContainer.innerHTML = '';

    stepsData.forEach((step, idx) => {
      const isCompleted = idx <= currentStepIndex;
      const isCurrent = idx === currentStepIndex;

      const stepDiv = document.createElement('div');
      stepDiv.className = `progress-step ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''}`;

      const iconWrap = document.createElement('div');
      iconWrap.className = 'step-icon-wrap';
      iconWrap.innerHTML = isCompleted ? `<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>`
        : `<div class="dot"></div>`;

      const label = document.createElement('div');
      label.className = 'step-label';
      label.textContent = step.label;

      const dateEl = document.createElement('div');
      dateEl.className = 'step-date';
      dateEl.textContent = step.date;

      stepDiv.appendChild(iconWrap);
      stepDiv.appendChild(label);
      stepDiv.appendChild(dateEl);
      progressContainer.appendChild(stepDiv);
    });



    // 4. Vertical Timeline
    const timelineContainer = document.getElementById('VerticalTimeline');
    timelineContainer.innerHTML = '';

    if (data.history && data.history.length > 0) {
      data.history.forEach((hist, index) => {
        const item = document.createElement('div');
        item.className = `timeline-item ${index === 0 ? 'current' : ''}`;

        const iconCol = document.createElement('div');
        iconCol.className = 'timeline-icon';
        iconCol.innerHTML = '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>';

        const contentCol = document.createElement('div');
        contentCol.className = 'timeline-content';

        const header = document.createElement('h4');
        header.textContent = hist.remarks || hist.status;
        if (index === 0) {
          const badge = document.createElement('span');
          badge.className = 'timeline-badge';
          badge.textContent = 'Current';
          header.appendChild(badge);
        }

        const msg = document.createElement('p');
        msg.textContent = `${hist.location ? hist.location + ' - ' : ''} ${hist.status}`;

        const date = document.createElement('p');
        date.className = 'timeline-date';
        date.textContent = formatDate(hist.scannedOn, true);

        contentCol.appendChild(header);
        contentCol.appendChild(msg);
        contentCol.appendChild(date);

        item.appendChild(iconCol);
        item.appendChild(contentCol);
        timelineContainer.appendChild(item);
      });
    }

    resultsDiv.classList.remove('hidden');

    // Reset width and force reflow to ensure CSS transition triggers when unhidden
    const lineFillEl = document.getElementById('ProgressLineFill');
    lineFillEl.style.width = '0%';
    lineFillEl.offsetHeight; // Force reflow

    // Set final width to trigger truck driving slide animation
    const progressPercentage = (currentStepIndex / (stepsData.length - 1)) * 100;
    lineFillEl.style.width = `${progressPercentage}%`;
  }

  // Auto-track if trackingId is provided in URL (e.g. /pages/tracking?trackingId=14344961431778)
  const urlParams = new URLSearchParams(window.location.search);
  const trackingIdParam = urlParams.get('trackingId');
  if (trackingIdParam) {
    input.value = trackingIdParam;
    form.requestSubmit();
  }
});
